import { useQuery } from '@tanstack/react-query';
import { fetchCategories, fetchCategoryById } from 'api/services/category';

const FETCH_CATEGORY_KEY = 'fetch-category';

const useCategoryQuery = (categoryId?: string) => {
  return useQuery({
    queryKey: [FETCH_CATEGORY_KEY, categoryId],
    queryFn: () => {
      return fetchCategoryById(categoryId!);
    },
    enabled: !!categoryId,
  });
};

export default useCategoryQuery;

export { FETCH_CATEGORY_KEY };
